import { isNativePlatform } from "@/native/platform";
import type React from "react";
import { useParams } from "react-router-dom";
import { useFullAppOverride } from "./fullAppOverride";
import { MobileHomeSurface } from "./MobileHomeSurface";

/**
 * Element for `/workspaces/:workspaceId` under the canvas-centric shell —
 * `HomeGate`'s scoped sibling. On native it renders the workspace-scoped
 * mobile surface in place, so every internal navigation to a workspace page
 * (the switcher, the composer scope chip, browser location links, deep
 * links) lands on the mobile experience without any caller changes. "Open
 * full app" flips the session override, observed reactively, and the same
 * route re-renders as the desktop workspace page.
 *
 * The `key` sits here, above `MobileHomeSurface`'s session provider, so a
 * workspace switch remounts it — otherwise workspace A's auto-created flow
 * session would leak into workspace B (see `WorkspaceDetailPage`).
 */
export function WorkspaceGate({ fullApp }: { fullApp: React.ReactNode }) {
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const fullAppOverride = useFullAppOverride();
  if (isNativePlatform() && !fullAppOverride && workspaceId) {
    return <MobileHomeSurface key={workspaceId} workspaceId={workspaceId} />;
  }
  return <>{fullApp}</>;
}

export default WorkspaceGate;
